import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import WithSpinner from "../../components/withSpinner/withSpinner.component";
import GatewaysView from "./views/GatewaysView";

const mapStateToProps = createStructuredSelector({
  user: (state) => state.user.currentUser,
});

const GatewaysContainer = compose(connect(mapStateToProps), WithSpinner)(GatewaysView);

export default GatewaysContainer;


